module.exports = __webpack_public_path__ + "img/pic-1.c110cc76.png";